import { type ReactNode } from 'react';

import { Stack, Typography } from '@mui/material';

import {
  SectionContainer,
  SectionContent,
  SectionHeader,
} from './StyledComponents';

interface ISectionProps {
  title: string;
  children: ReactNode;
  headerAction?: ReactNode;
  description?: string;
}

const Section = ({
  children,
  title,
  headerAction,
  description,
}: ISectionProps) => (
  <SectionContainer>
    <SectionHeader>
      <Stack spacing={0.25}>
        <Typography variant="h3">{title}</Typography>
        {description && (
          <Typography variant="body2" color="text.secondary">
            {description}
          </Typography>
        )}
      </Stack>
      {headerAction && headerAction}
    </SectionHeader>
    <SectionContent>{children}</SectionContent>
  </SectionContainer>
);
export default Section;
